import { useEffect, useState } from "react";
// UTILS
import {
  extractDailyIndependenceData,
  ProcessedDailyIndependenceDataType,
} from "@intelligentlilli/lilli-utils";
// DateTime
import {
  subDays,
  subMonths,
  endOfDay,
  isSameDay,
  isBefore,
  isAfter,
} from "date-fns";
import { IndependenceAnalysisType } from "@intelligentlilli/api-layer";
import { MainDoorActivityReduxType } from "State/slices/serviceUsersData-slice";

export const usePrepareIndependenceData = (
  independenceAnalysis: IndependenceAnalysisType | undefined,
  mainDoorActivity: MainDoorActivityReduxType | undefined,
  startDateString: string,
  endDateString: string,
  dateType: string
) => {
  const [independenceData, setIndependenceData] =
    useState<ProcessedDailyIndependenceDataType>();
  const [independenceDataPrevious, setIndependenceDataPrevious] =
    useState<ProcessedDailyIndependenceDataType>();
  const [frontDoorEvents, setFrontDoorEvents] =
    useState<MainDoorActivityReduxType>();

  useEffect(() => {
    const endDate = endDateString
      ? endOfDay(new Date(endDateString))
      : new Date();
    const startDate = startDateString
      ? endOfDay(new Date(startDateString))
      : new Date();

    independenceAnalysis &&
      setIndependenceData(
        extractDailyIndependenceData(
          independenceAnalysis?.dailyResults,
          subDays(startDate, 1),
          endDate
        )
      );

    // Get the independence data for the previous period (day, week or month). This is used to display the previous time outside element in the independence view
    independenceAnalysis &&
      setIndependenceDataPrevious(
        extractDailyIndependenceData(
          independenceAnalysis?.dailyResults,
          dateType === "week" ? subDays(startDate, 6) : subMonths(startDate, 1),
          dateType === "week" ? subDays(startDate, 6) : subMonths(endDate, 1)
        )
      );

    // Get the main door events
    mainDoorActivity &&
      setFrontDoorEvents(
        mainDoorActivity?.filter(
          (day) =>
            (isBefore(new Date(day.date), endDate) &&
              isAfter(new Date(day.date), startDate)) ||
            isSameDay(new Date(day.date), startDate) ||
            isSameDay(new Date(day.date), endDate)
        )
      );
  }, [
    independenceAnalysis,
    mainDoorActivity,
    endDateString,
    startDateString,
    dateType,
  ]);

  return {
    independenceData,
    independenceDataPrevious,
    frontDoorEvents,
  };
};
